
<div class="compare-view">
  <ftu-block
    dismiss-key="compare"
    icon="multiline_chart"
    title="This is the Compare tool"
    description="The Compare tool allows you to compare the sales histories of multiple verified cards on the same graph. Simply search the cards you want to compare and toggle between time frames to discover trends, inefficiencies, and more. You can also pick cards to compare right from their profiles and save comparison sets for future use."
  />

  <page-header title="Compare">
    <template #actions>
      <saved-options-dropdown
        label="Saved Comparisons"
        :options="comparisons"
        :save-disabled="!showSaveButton"
        @edit="editComparison"
        @delete="removeComparison"
        @select="loadComparison"
        @save="saveComparison"
      />
    </template>
  </page-header>

  <template>
    <div class="tabs">
      <tab :active="type === 'cards'" @click="type = 'cards'">
        Cards
      </tab>

      <tab :active="type === 'indexes'" @click="type = 'indexes'">
        Indexes
      </tab>
    </div>

    <div class="wrapper">
      <div v-if="!disabled" class="search-container">
        <card-search
          v-show="type === 'cards'"
          keep-open-on-select
          :exclude-ids="ids"
          :disabled="disabled"
          @select="addCard"
        />

        <div v-show="type === 'indexes'">
          <index-search
            @selectPlayer="addIndex"
            @selectIndex="addIndex"
          />
        </div>
      </div>

      <empty-state
        v-if="showEmptyState"
        icon="multiline_chart"
        title="Search for items to compare"
      />

      <template v-else>
        <graph
          :labels="labels"
          :datasets="datasets"
          :zoom.sync="zoom"
          :scale.sync="scale"
          :y-axis-type="yAxisType"
        />

        <compare-table
          v-if="items.length"
          :items="items"
          :zoom="zoom"
          :type="type"
          @removeItem="removeItem"
        />
      </template>
    </div>
  </template>

  <portal to="fullscreen">
    <compare-save-modal
      :open="showSaveModal"
      :editing="editing"
      :items="items"
      :type="type"
      @close="handleClose"
    />
  </portal>
</div>
